module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAk4AAAGQAQMAAABiS310AAAAA1BMVEURHDB6MJlsAAAAAXRSTlNPpoWEZwAAADRJREFUeNrtwTEBAAAAwiD7p7bETmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJEDdTAAAQju9UgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/zz.png
// module id = vPsY
// module chunks = 0